import { observable, action, flow } from 'mobx';
import Stores from 'config/Stores';
import { Toast } from 'antd-mobile';
import Upload from 'utils/upload';
import TimMobx from 'pages/TIM/Common/tim';
import Serv from './AccountServ';

class AccountMod {
  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   * 上传头像
   */
  onImagePicker = (file, obj) => {
    const { callback, scene = 'avatar-member' } = obj || {};
    // if (type == 'add') {
    // const { file } = files[files.length - 1];
    if (!file) {
      return Toast.info('请选择一张图片');
    }
    Toast.loading('上传中,请稍后', 100);
    Upload.filecCmpress(file, { quality: 0.8 }, (newFile) => {
      Upload.uploadObject2OSS({ file: newFile, scene })
        .then((res) => {
          Toast.hide();
          if (res) {
            if (callback) {
              callback(res);
            } else {
              this.uploadAvatar(res);
            }
          } else {
            Toast.info('上传失败，请重新上传');
          }
        })
        .catch((err) => {
          Toast.info(err.message || '上传失败，请重新上传');
        });
    });
  };

  /**
   *  获取跳转链接
   *
   */
  getWechatLoginUrl = flow(function* (params) {
    try {
      const { data, resultCode, resultMsg } = yield Serv.getWechatLoginUrl(params);
      if (+resultCode === 0) {
        return data;
      }
    } catch (error) {}
  });

  /**
   * 上传头像
   */
  uploadAvatar = flow(function* (avatar) {
    try {
      yield Serv.uploadAvatar({ avatar });
      Stores.AppMod.getPersonalInfo();
      TimMobx.setUpdateMyProfile({
        avatar: avatar || '' // 头像
      });
      // 神策数据发送
      window.sensors.track('userInfoModify', { modifyType: '上传头像' });
    } catch (error) {}
  });

  /**
   * 查询是否绑定企微用户
   */
  queryUserBindWorkWechat = flow(function* () {
    try {
      const userInfo = Stores.AppMod.userInfo || {};
      const { data, resultCode } = yield Serv.queryUserBindWorkWechat({ userId: userInfo.id });
      if (resultCode == '0') {
        return data;
      }
      return false;
    } catch (error) {
      return false;
    }
  });

  /**
   * 绑定企微用户
   * @param {String} code  企微授权拿回来的code
   */
  bindUserWorkWechat = flow(function* (code) {
    try {
      const { userInfo = {}, workWechatAgentId } = Stores.AppMod || {};
      const params = {
        code,
        userId: userInfo.id,
        loginSource: 10,
        agentId: workWechatAgentId
      };
      const { data, resultCode } = yield Serv.bindUserWorkWechat(params);
      if (resultCode == '0') {
        Toast.info('绑定成功');
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  });

  /**
   * 企微解除绑定
   *
   */
  secureWorkWechatBind = flow(function* () {
    try {
      const userInfo = Stores.AppMod.userInfo || {};
      const { data, resultCode } = yield Serv.secureWorkWechatBind({ userId: userInfo.id });

      if (resultCode == '0') {
        Toast.info('解绑成功');
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  });

  /**
   * 查询Google是否登录
   *
   */
  checkGoogleBind = flow(function* () {
    try {
      const userInfo = Stores.AppMod.userInfo || {};
      const data = userInfo.data || {};
      if (data.googleBind === 1) {
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  });

  /**
   * 谷歌解除绑定
   *
   */
  unbindGoogle = flow(function* () {
    try {
      const { resultCode } = yield Serv.unbindGoogle({});

      if (resultCode == '0') {
        const userInfo = Stores.AppMod.userInfo || {};
        yield Stores.AppMod.saveLoginInfo(userInfo).then(() => {
          console.log('解绑后重新获取用户信息');
        });
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  });
}

export default AccountMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/Account/AccountMod.js